
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVerticalEmpty as ObiBatteryVerticalEmptyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-empty.js';
 
 
 

 
 export const ObiBatteryVerticalEmpty = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-empty',
   elementClass: ObiBatteryVerticalEmptyElement,
   events: {
     
   }
  });
 
 